
import { Link } from "react-router-dom";
import { Copy, Edit, FileText, LinkIcon, QrCode, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

interface CodeItemProps {
  code: {
    code: string;
    title: string | null;
  };
  onCopyCode: (code: string) => Promise<void>;
  onCopyUrl: (code: string) => Promise<void>;
  onShowQr: (code: string) => void;
  onEditCode: (code: string, title: string | null) => void;
  onDeleteCode: (code: string) => void;
}

export const CodeItem = ({
  code,
  onCopyCode,
  onCopyUrl,
  onShowQr,
  onEditCode,
  onDeleteCode,
}: CodeItemProps) => {
  const handleCopyTitle = async () => {
    if (code.title) {
      await navigator.clipboard.writeText(code.title);
    }
  };

  return (
    <Popover key={code.code}>
      <PopoverTrigger asChild>
        <div className="px-3 py-2 bg-muted rounded-md text-sm font-mono flex flex-col cursor-pointer hover:bg-muted/80">
          <div className="flex items-center justify-between">
            <span className="text-lg">{code.code}</span>
          </div>
          {code.title && <div className="mt-1 text-xs text-muted-foreground truncate">{code.title}</div>}
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-4">
        <div className="space-y-4">
          <div className="text-center border-b pb-2">
            <h4 className="font-medium">Código {code.code}</h4>
            {code.title && <p className="text-xs text-muted-foreground">{code.title}</p>}
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Button variant="outline" size="sm" onClick={() => onCopyCode(code.code)} className="w-full">
              <Copy className="h-4 w-4 mr-1" />
              Código
            </Button>
            <Button variant="outline" size="sm" onClick={() => onCopyUrl(code.code)} className="w-full">
              <LinkIcon className="h-4 w-4 mr-1" />
              Copiar URL
            </Button>
            {code.title && (
              <Button variant="outline" size="sm" onClick={handleCopyTitle} className="w-full">
                <Copy className="h-4 w-4 mr-1" />
                Título
              </Button>
            )}
            <Button variant="outline" size="sm" onClick={() => onShowQr(code.code)} className="w-full">
              <QrCode className="h-4 w-4 mr-1" />
              Ver QR
            </Button>
            <Button variant="outline" asChild size="sm" className="w-full">
              <Link to={`/admin/submissions?code=${code.code}`}>
                <FileText className="h-4 w-4 mr-1" />
                Envíos
              </Link>
            </Button>
            <Button variant="outline" size="sm" onClick={() => onEditCode(code.code, code.title)} className="w-full">
              <Edit className="h-4 w-4 mr-1" />
              Editar
            </Button>
            <Button 
              variant="outline" 
              size="sm" 
              onClick={() => onDeleteCode(code.code)} 
              className="w-full text-red-600 hover:text-red-700 hover:bg-red-50"
            >
              <Trash2 className="h-4 w-4 mr-1" />
              Eliminar
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
